<template>
  <div>
    <el-dialog title="三级考点"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="1200rem"
               :before-close="handleClose">
      <el-table :data="tableData"
                height="520rem"
                ref="theTable"
                default-expand-all
                @row-click="getOpenDetail"
                :tree-props="{children: 'child'}"
                row-key="knowledgeId"
                style="width: 100%">
        <el-table-column prop="text"
                         align="left"
                         width="400rem"
                         label="考点">
          <template slot-scope="{row}">
            <div class="checkpoint">
              {{`${row.knowledgeDesc}`}}<span class="textlevel">{{`(${row.level}级考点)`}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rate"
                         align="left"
                         label=" 得分率">
          <template slot-scope="{row}">
            <div class="checkpoint"
                 v-show="row.level == 3">
              {{row.rate}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="do_question_count"
                         align="left"
                         label=" 训练次数">
          <template slot-scope="{row}">
            <div class="checkpoint"
                 v-show="row.level == 3">
              {{row.doQuestionCount}}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="text"
                         align="left"
                         label="易错指数">
          <template slot-scope="{row}">
            <div class="checkpoint"
                 v-show="row.level == 3">
              {{row.errorProne}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="500">
          <template slot-scope="{row}">
            <div class="btn"
                 v-if="row.level == 3&&row.videoCount>0&&userInfo.show_video!=0"
                 @click="showVideo(row)">
              考点讲解
            </div>
            <div class="btn"
                 v-if="row.level == 3&&row.lecture_data.length>0"
                 @click="viewLecture(row)">
              查看讲义
            </div>
            <div class="btn"
                 v-show="row.level == 3"
                 @click="doPaper(row)">
              开始训练
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <LectureForm ref="LectureFormRef" />
    <VideoForm ref="VideoFormRef" />
  </div>
</template>
<script>
import LectureForm from './lecture.vue'
import VideoForm from './video.vue'
import { getTwoCheckpoint } from '@/api/checkpoint.js'
export default {
  data () {
    return {
      form: {},
      tableData: [],
      dialogVisible: false,
      userInfo: {},
      type: ''
    }
  },
  components: {
    LectureForm, VideoForm
  },
  mounted () {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  },
  methods: {
    getOpenDetail (row) {
      this.$refs.theTable.toggleRowExpansion(row);
    },
    handleClose () {
      this.dialogVisible = false
    },
    viewLecture (row) {
      this.$refs.LectureFormRef.text = '三级讲义数据'
      this.$refs.LectureFormRef.initList(row.lecture_data)
      this.$refs.LectureFormRef.dialogVisible = true
    },
    showVideo (row) {
      let params

      params = {
        id: row.knowledgeId
      }
      this.$refs.VideoFormRef.text = '考点'
      this.$refs.VideoFormRef.initList(params, null)
      this.$refs.VideoFormRef.dialogVisible = true
    },
    doPaper (row) {
      console.log(row, 'row')
      let params = {
        subject_id: row.subjectId,
        knowledge_id: row.knowledgeId,
        is_weak: 1,
        type: 5,
      }

      this.$router.push('/doPaper?type=5&form=' + JSON.stringify(params))
    },
    async initList (row) {

      this.tableData = [...row]
      // console.log('ssss', this.tableData);
      this.tableData = this.tableData.filter(item => item.child.length > 0)
    }
    // async save () {
    //   await collect(this.form)
    //   this.handleClose()
    //   this.$message.success('收藏成功，可前往错题本查看')
    // }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20rem;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4rem;
}

::v-deep .el-dialog {
  border-radius: 20rem;
  min-height: 600rem;
  margin-top: 198rem !important;
}

::v-deep .el-table th,
.el-table tr {
  background: #f6f6f6;
}
::v-deep .cell {
  // text-indent: 60rem;
  display: flex;

  font-size: 20rem;
}

.checkpoint {
  color: var(--light-333333, #333);
  font-size: 20rem;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 150% */
  .textlevel {
    color: var(--light-999999, #999);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
}
.btn {
  width: 140rem;
  height: 44rem;
  background: #2196f3;
  border-radius: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20rem;
  font-weight: bold;
  color: #ffffff;
  text-indent: 0;
  cursor: pointer;
  margin-right: 12rem;
}
</style>